export const VendorDetailUnavailableOffersPageSize = 5;
export const VendorDetailUnavailableOffersPageSize = 5;
